<template>
    <div class="installer">
        <div v-if="$installer.canInstall">
            <div>
                <button class="btn " @click="$installer.prompt">{{ $t('common.install_button') }}</button>
            </div>
        </div>
        <div class="popup" v-if="showPopup">
            <div class="box">
                <a href="javascript:void(0);" class="close-infobox" @click="showPopup = false"></a>
                Per poter scaricare l'app da Safari premi l'icona <span class="icon"><svg viewBox="0 0 45 60"><path fill-rule="evenodd" d="M43.5 60h-42A1.5 1.5 0 0 1 0 58.5v-39A1.5 1.5 0 0 1 1.5 18H15v3H3v36h39V21H30v-3h13.5c.828 0 1.5.673 1.5 1.5v39a1.5 1.5 0 0 1-1.5 1.5zM30.451 11.377L24 5.066v32.238a1.5 1.5 0 1 1-3 0V5.066l-6.452 6.311a1.502 1.502 0 0 1-2.121-.022 1.501 1.501 0 0 1 .024-2.122l8.976-8.78a1.5 1.5 0 0 1 2.121-.024l9 8.805a1.5 1.5 0 1 1-2.097 2.143z"/></svg></span> e poi la voce <strong>Aggiungi a Home</strong>.
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'pwa-installer',
        mounted() {
            this.init();
        },
        data() {
            return {
                showPopup: false
            }
        },
        methods: {
            init() {
                const userAgent = window.navigator.userAgent.toLowerCase();
                const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
                if (/iphone|ipad|ipod|safari/.test( userAgent ) && !isInStandaloneMode()) {
                    if(/Chrome/i.test(navigator.userAgent)) {

                    } else {
                        this.showPopup = true;
                    }
                }
            }
        }
    };
</script>
<style lang="scss">
    .popup {
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
        background: rgba(#000, 0.9);
        z-index: 100000;
        opacity: 1;
        pointer-events: all;
        .box {
            display: block;
            background: #fff;
            width: 90%;
            height: auto;
            padding: 60px 30px;
            position: relative;
            font-size: 20px;
            line-height: 1.6em;
            opacity: 1;
            .close-infobox {
                position: absolute;
                top: 30px;
                right: 30px;
                display: block;
                width: 35px;
                height: 35px;
                &:before,
                &:after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    background: #f00;
                    width: 30px;
                    height: 1px;
                }
                &:before {
                    transform: translate(-50%, -50%) rotate(-45deg);
                }
                &:after {
                    transform: translate(-50%, -50%) rotate(45deg);
                }
            }
            .icon {
                display: inline-block;
                width: 20px;
                height: auto;
                margin: 0 10px;
                transform: translateY(7px);
                svg {
                    width: 100%;
                    height: auto;
                    fill: #000;
                }
            }
        }
    }
</style>
